import type { Reducer } from 'redux';
import { initActionTypes } from '@makemydeal/dr-shared-store';
import { WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import { SET_WORKFLOW_EVALUATION, SET_WORKFLOW_STATUS } from './workflowActionTypes';
import { mapApplicationStateToWorkflowStatus } from './applicationStateMap';
import { type IWorkflowState } from './types';

const initialState: IWorkflowState = {
    // IDLE: bootstrap API has not yet returned. workflowEvaluatorMiddleware will
    // not dispatch navigation until bootstrapIdleRule stops returning IDLE.
    status: WorkflowStatus.IDLE,
    shouldNavigateOnWorkflowChange: true
};

export const workflowReducer: Reducer<IWorkflowState> = (state = initialState, action: any) => {
    switch (action.type) {
        case initActionTypes.INIT_PENCIL_SUCCESS: {
            // Seed WorkflowStatus directly from the server-computed applicationState.
            // The server runs the same rule logic (showroomApplicationState.ts) so this
            // value is authoritative at bootstrap. workflowEvaluatorMiddleware skips
            // INIT_PENCIL_SUCCESS to avoid overwriting this with a client re-evaluation.
            const status = mapApplicationStateToWorkflowStatus(action.payload?.applicationState);
            return { ...state, status };
        }
        case SET_WORKFLOW_STATUS:
            return { ...state, status: action.payload };
        case SET_WORKFLOW_EVALUATION:
            return { ...state, shouldNavigateOnWorkflowChange: action.payload };
        default:
            return state;
    }
};
